<script>
	import { Router, Route } from "svelte-routing";
	import {store} from './stores.js';
	
	import Auth from "./routes/Auth.svelte";
	import AuthForgot from "./routes/AuthForgot.svelte";
	import AccessDenied from "./routes/AccessDenied.svelte";
	import Editor from "./routes/Editor.svelte";
	
	import AgentPanel from './routes/AgentPanel.svelte';
	import AgentProducts from './routes/AgentProducts.svelte';
	import AgentActivity from './routes/AgentActivity.svelte';
	import AgentActivityForm from './routes/AgentActivityForm.svelte';
	import AgentActivityView from './routes/AgentActivityView.svelte';
	
	import MemberDashboard from "./routes/MemberDashboard.svelte";
	import MemberForm from "./routes/MemberForm.svelte";
	import MemberCert from "./routes/MemberCert.svelte";
	import MemberEvents from "./routes/MemberEvents.svelte";
	import MemberEventsView from "./routes/MemberEventsView.svelte";
	import MemberTest from "./routes/MemberTest.svelte";
	import MemberTestView from './routes/MemberTestView.svelte';
	
	const user = store('credentials', 'appUserAuth');
	
	export let url = "";
</script>

<!-- loader -->
<div id="loader" style="display: none">
	<div class="spinner-border text-primary" role="status"></div>
</div>
<!-- * loader -->

<!-- App Capsule -->
<Router url="{url}">
	<Route path="/" component={Auth} />
	<Route path="/forgot" component={AuthForgot} />
	
	{#if $user.idRegPred > 0 || $user.id > 0}
		{#if $user.idRegPred > 0}
			<Route path="/panel" component={AgentPanel} />
			<Route path="/products" component={AgentProducts} />
			<Route path="/activity" component={AgentActivity} />
			<Route path="/activity/add" component={AgentActivityForm} />
			<Route path="/activity/view/:id" let:params>
				<AgentActivityView id="{params.id}" />
			</Route>
			<Route path="/activity/edit/:id" let:params>
				<AgentActivityForm id="{params.id}" />
			</Route>
		{/if}
		
		{#if $user.id > 0}
			<Route path="/dashboard" component={MemberDashboard} />
			<Route path="/member" component={MemberForm} />
			<Route path="/cert" component={MemberCert} />
			<Route path="/events" component={MemberEvents} />
		{/if}
		
		<Route path="/events/view/:id" let:params>
			<MemberEventsView id="{params.id}" />
		</Route>
		
		{#if $user.id > 0}
			<Route path="/events/view/:id/tests" component={MemberTest} />
			<Route path="/events/view/:evid/tests/view/:tid" let:params>
				<MemberTestView evid="{params.evid}" tid="{params.tid}" />
			</Route>
		{/if}
		
		<Route path="/editor" component={Editor} />
	{:else}
		<Route path="/events/view/:id" let:params>
			<MemberEventsView id="{params.id}" />
		</Route>
	{/if}
	
	<Route path="/*" component={AccessDenied} />
</Router>
<!-- * App Capsule -->
